import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import MainContent from "../../layouts/maincontent/MainContent";
import InputElement from "../../shared/form/InputElement";
import TextAreaElement from "../../shared/form/TextAreaElement";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/Loading/LoadingSpinner";
import { get_request_details } from "../../adapters/apis/taxDispute/details";
import { get } from "../../adapters/xhr/api";

import arrowRightShort from "../../assets/img/arrow-right-short.svg";

const RequestDetails = () => {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    get_request_details(id)
      .then((res) => {
        setIsLoading(false);
        setData(res?.data?.data);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          navigate("/not-found");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const renderRequestStatusFields = () => {
    const statusCode = parseInt(data?.request_status_code);
    switch (statusCode) {
      case 1:
        return null;

      case 2:
        return (
          <>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="depositing_date"
                name="depositing_date"
                labelClassName={`form-label`}
                labelText="تاريخ الإيداع"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="depositing_date"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={data?.depositing_date || ""}
                disabled={true}
              />
            </div>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="first_session_date"
                name="first_session_date"
                labelClassName={`form-label`}
                labelText="تاريخ أول جلسة"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="first_session_date"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={data?.first_session_date || ""}
                disabled={true}
              />
            </div>
          </>
        );

      case 3:
        return (
          <>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="non_depositing_date"
                name="non_depositing_date"
                labelClassName={`form-label`}
                labelText="تاريخ عدم الإيداع"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="non_depositing_date"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={data?.non_depositing_date || ""}
                disabled={true}
              />
            </div>
            <div className="col-md-12">
              <TextAreaElement
                mb4="mb-4"
                labelHtmlFor="decline_reasons"
                labelClassName={` form-label`}
                labelText="أسباب الرفض"
                teaxtAreaClassName="form-control font-grey"
                teaxtAreaID="decline_reasons"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                name="decline_reasons"
                value={data?.decline_reasons || ""}
                disabled="disabled"
              />
            </div>
          </>
        );

      case 4:
        return (
          <>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="recommendation_result_date"
                name="recommendation_result_date"
                labelClassName={`form-label`}
                labelText="تاريخ نتيجة التوصية"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="recommendation_result_date"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={data?.recommendation_result_date || ""}
                disabled={true}
              />
            </div>
            {/* documents */}
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="recommendation_confirmation_document"
                name="recommendation_confirmation_document"
                labelClassName={`form-label`}
                labelText="وثيقة اعتماد التوصية"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="recommendation_confirmation_document"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={
                  data?.recommendation_confirmation_document_name ? "الملف" : ""
                }
                isIcon={data?.recommendation_confirmation_document_img || ""}
                disabled={true}
                idDownload={id}
                filedDownload="recommendationConfirmationDocument"
              />
            </div>
          </>
        );

      case 5:
        return (
          <>
            <div className="col-md-4">
              <InputElement
                mb4="mb-4"
                labelHtmlFor="recommendation_result_date"
                name="recommendation_result_date"
                labelClassName={`form-label`}
                labelText="تاريخ نتيجة التوصية"
                inputType="text"
                inputClassName={`form-control font-grey`}
                inputID="recommendation_result_date"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                value={data?.recommendation_result_date || ""}
                disabled={true}
              />
            </div>
            <div className="col-md-12">
              <TextAreaElement
                mb4="mb-4"
                labelHtmlFor="notes"
                labelClassName={` form-label`}
                labelText="ملاحظات"
                teaxtAreaClassName="form-control font-grey"
                teaxtAreaID="notes"
                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                name="notes"
                value={data?.notes || ""}
                disabled="disabled"
              />
            </div>
          </>
        );

      default:
        return null;
    }
  };
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <MainContent>
          <section className={`section-content pt-md-0 pt-4 pb-5`}>
            <div className={`container`}>
              <div className="d-flex align-items-center">
                <Link
                  to={"/tax-dispute-request/list-data"}
                  className="d-flex align-items-center text-decoration-none"
                  id="list-data-button"
                >
                  <img
                    src={arrowRightShort}
                    alt="arrow icon"
                    className="img-fluid"
                    style={{ width: "40px", height: "40px" }}
                  />
                </Link>
                <h3 className="box-title mb-0 fw-bold">تفاصيل الطلب</h3>
              </div>

              <div className={`card-box`}>
                {/* buttons */}
                <div className={`box-content`}>
                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>بيانات الطلب</h4>
                    {
                      <div className="row">
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="request_number"
                            name="request_number"
                            labelClassName={`form-label`}
                            labelText="رقم الطلب"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="request_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.request_number || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="request_date"
                            name="request_date"
                            labelClassName={`form-label`}
                            labelText="تاريخ تقديم الطلب"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="request_date"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.request_date || ""}
                            disabled={true}
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="request_status"
                            name="request_status"
                            labelClassName={`form-label`}
                            labelText="حالة الطلب"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="request_status"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.request_status || ""}
                            disabled={true}
                          />
                        </div>
                        {renderRequestStatusFields()}
                      </div>
                    }
                  </div>
                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>بيانات مقدم الطلب </h4>
                    <div className="row">
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="submitter_request_character"
                          name="submitter_request_character"
                          labelClassName={`form-label`}
                          labelText="صفة مقدم الطلب"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="submitter_request_character"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            data?.submitter_request_data
                              ?.submitter_request_character || ""
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="tax_payer_first_name"
                          name="tax_payer_first_name"
                          labelClassName={`form-label`}
                          labelText="الاسم الاول للممول/المكلف"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="tax_payer_first_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.tax_payer_first_name || ""}
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="tax_payer_rest_name"
                          name="tax_payer_rest_name"
                          labelClassName={`form-label`}
                          labelText="باقي الاسم للممول/المكلف"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="tax_payer_rest_name"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.tax_payer_rest_name || ""}
                          disabled={true}
                        />
                      </div>
                      {/* if the submitter is agent or legal representative */}
                      {[4, 5].includes(
                        parseInt(
                          data?.submitter_request_data
                            ?.submitter_request_character_code,
                        ),
                      ) && (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="first_name"
                              name="first_name"
                              labelClassName={`form-label`}
                              labelText="الاسم الاول لمقدم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="first_name"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data.first_name || ""
                              }
                              disabled={true}
                            />
                          </div>

                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="rest_name"
                              name="rest_name"
                              labelClassName={`form-label`}
                              labelText="باقي الاسم لمقدم الطلب"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="rest_name"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data?.rest_name || ""
                              }
                              disabled={true}
                            />
                          </div>
                        </>
                      )}

                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="email"
                          name="email"
                          labelClassName={`form-label`}
                          labelText="البريد الإلكتروني"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="email"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.submitter_request_data?.email || ""}
                          disabled={true}
                        />
                      </div>

                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="phone_number"
                          name="phone_number"
                          labelClassName={`form-label`}
                          labelText="رقم الهاتف"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="phone_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            data?.submitter_request_data?.phone_number || ""
                          }
                          disabled={true}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="nationality"
                          name="nationality"
                          labelClassName={`form-label`}
                          labelText="الجنسية"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="nationality"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={
                            data?.submitter_request_data?.nationality || ""
                          }
                          disabled={true}
                        />
                      </div>
                      {/* if the nationality is egyptian */}
                      {[63].includes(
                        parseInt(
                          data?.submitter_request_data?.nationality_code,
                        ),
                      ) ? (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="national_id"
                              name="national_id"
                              labelClassName={`form-label`}
                              labelText="الرقم القومي"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="national_id"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data?.national_id || ""
                              }
                              disabled={true}
                            />
                          </div>
                          {/* images */}
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="national_id_name"
                              name="national_id_name"
                              labelClassName={`form-label`}
                              labelText="صورة الرقم القومي"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="national_id_name"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data?.national_id_name
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                data?.submitter_request_data?.national_id_img ||
                                ""
                              }
                              disabled={true}
                              idDownload={data?.profile_id}
                              filedDownload="nationalIdFile"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="passport_number"
                              name="passport_number"
                              labelClassName={`form-label`}
                              labelText="رقم جواز السفر"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="passport_number"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data?.passport_number ||
                                ""
                              }
                              disabled={true}
                            />
                          </div>
                          {/* images */}
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="passport_name"
                              name="passport_name"
                              labelClassName={`form-label`}
                              labelText="صورة جواز السفر"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="passport_name"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data?.passport_name
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                data?.submitter_request_data?.passport_img || ""
                              }
                              disabled={true}
                              idDownload={data?.profile_id}
                              filedDownload="passportNumFile"
                            />
                          </div>
                        </>
                      )}
                      {/* if the submitter is agent or legal representative */}
                      {[4, 5].includes(
                        parseInt(
                          data?.submitter_request_data
                            ?.submitter_request_character_code,
                        ),
                      ) && (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="agency_document_name"
                              name="agency_document_name"
                              labelClassName={`form-label`}
                              labelText="صورة سند التوكيل/سند التمثيل القانوني"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="agency_document_name"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={
                                data?.submitter_request_data
                                  ?.agency_document_name
                                  ? "الملف"
                                  : ""
                              }
                              isIcon={
                                data?.submitter_request_data
                                  ?.agency_document_img || ""
                              }
                              disabled={true}
                              idDownload={id}
                              filedDownload="agencyRepresentativeDocumentFiles"
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <TextAreaElement
                          mb4="mb-4"
                          labelHtmlFor="correspondence_address"
                          labelClassName={` form-label`}
                          labelText="عنوان المراسلة"
                          teaxtAreaClassName="form-control font-grey"
                          teaxtAreaID="correspondence_address"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          name="correspondence_address"
                          value={
                            data?.submitter_request_data
                              ?.correspondence_address || ""
                          }
                          disabled="disabled"
                        />
                      </div>
                    </div>
                  </div>

                  <div className={`box`}>
                    <h4 className={`box-title mb-4`}>تفاصيل الطلب</h4>
                    <div className="row">
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="governorate"
                          name="governorate"
                          labelClassName={`form-label`}
                          labelText="محافظة"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="governorate"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.governorate || ""}
                          disabled="disabled"
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="office"
                          name="office"
                          labelClassName={`form-label`}
                          labelText="مأمورية"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="office"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.office || ""}
                          disabled="disabled"
                        />
                      </div>
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="tax_type"
                          name="tax_type"
                          labelClassName={`form-label`}
                          labelText="نوع الضريبة"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="tax_type"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.tax_type || ""}
                          disabled="disabled"
                        />
                      </div>
                    </div>
                    {/* if tax type is Built Property Tax */}
                    {[1].includes(parseInt(data?.tax_type_code)) ? (
                      <div className="row">
                        <div className="col-md-12">
                          <TextAreaElement
                            mb4="mb-4"
                            labelHtmlFor="property_address"
                            labelClassName={` form-label`}
                            labelText="عنوان العقار"
                            teaxtAreaClassName="form-control font-grey"
                            teaxtAreaID="property_address"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            name="property_address"
                            value={data?.property_address || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="expolitation_type"
                            name="expolitation_type"
                            labelClassName={`form-label`}
                            labelText="نوع الاستغلال"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="expolitation_type"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.expolitation_type || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="tax_period"
                            name="tax_period"
                            labelClassName={`form-label`}
                            labelText="الفترة الضريبية"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="tax_period"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.tax_period || ""}
                            disabled="disabled"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-md-12">
                          <TextAreaElement
                            mb4="mb-4"
                            labelHtmlFor="activity_address"
                            labelClassName={` form-label`}
                            labelText="عنوان النشاط"
                            teaxtAreaClassName="form-control font-grey"
                            teaxtAreaID="activity_address"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            name="activity_address"
                            value={data?.activity_address || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="activity_type"
                            name="activity_type"
                            labelClassName={`form-label`}
                            labelText="نوع النشاط"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="activity_type"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.activity_type || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="activity_date_from"
                            name="activity_date_from"
                            labelClassName={`form-label`}
                            labelText="تاريخ إقامة النشاط من"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="activity_date_from"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.activity_date_from || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="activity_date_to"
                            name="activity_date_to"
                            labelClassName={`form-label`}
                            labelText="تاريخ إقامة النشاط إلى"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="activity_date_to"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.activity_date_to || ""}
                            disabled="disabled"
                          />
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-md-12">
                        <TextAreaElement
                          mb4="mb-4"
                          labelHtmlFor="dispute_subject"
                          labelClassName={` form-label`}
                          labelText="موضوع المنازعة"
                          teaxtAreaClassName="form-control font-grey"
                          teaxtAreaID="dispute_subject"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          name="dispute_subject"
                          value={data?.dispute_subject || ""}
                          disabled="disabled"
                        />
                      </div>
                    </div>
                    <div className="row">
                      {[1].includes(parseInt(data?.tax_type_code)) ? (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="disputed_annual_base_value"
                              name="disputed_annual_base_value"
                              labelClassName={`form-label`}
                              labelText="قيمة الوعاء السنوي المتنازع عليه"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="disputed_annual_base_value"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={data?.disputed_annual_base_value || ""}
                              disabled="disabled"
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="disputed_annual_tax_value"
                              name="disputed_annual_tax_value"
                              labelClassName={`form-label`}
                              labelText="قيمة الضريبة السنوية المتنازع عليها"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="disputed_annual_tax_value"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={data?.disputed_annual_tax_value || ""}
                              disabled="disabled"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="disputed_tax_value"
                              name="disputed_tax_value"
                              labelClassName={`form-label`}
                              labelText="قيمة الضريبة المتنازع عليها"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="disputed_tax_value"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={data?.disputed_tax_value || ""}
                              disabled="disabled"
                            />
                          </div>
                          <div className="col-md-4">
                            <InputElement
                              mb4="mb-4"
                              labelHtmlFor="disputed_increase_value"
                              name="disputed_increase_value"
                              labelClassName={`form-label`}
                              labelText="قيمة الزيادة (الغرامة) المتنازع عليها"
                              inputType="text"
                              inputClassName={`form-control font-grey`}
                              inputID="disputed_increase_value"
                              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                              value={data?.disputed_increase_value || ""}
                              disabled="disabled"
                            />
                          </div>
                        </>
                      )}
                      <div className="col-md-4">
                        <InputElement
                          mb4="mb-4"
                          labelHtmlFor="dispute_reviewer"
                          name="dispute_reviewer"
                          labelClassName={`form-label`}
                          labelText="الجهة المنظور أمامها النزاع حالياً"
                          inputType="text"
                          inputClassName={`form-control font-grey`}
                          inputID="dispute_reviewer"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={data?.dispute_reviewer || ""}
                          disabled="disabled"
                        />
                      </div>
                    </div>
                    {/* if the dispute reviewer is court */}
                    {[1].includes(parseInt(data?.dispute_reviewer_code)) ? (
                      <div className="row">
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="court"
                            name="court"
                            labelClassName={`form-label`}
                            labelText="محكمة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="court"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.court?.court || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="lawsuit_number"
                            name="lawsuit_number"
                            labelClassName={`form-label`}
                            labelText="رقم الدعوى"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="lawsuit_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.court?.lawsuit_number || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="filing_lawsuit_date"
                            name="filing_lawsuit_date"
                            labelClassName={`form-label`}
                            labelText="تاريخ إيداع الدعوى"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="filing_lawsuit_date"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.court?.filing_lawsuit_date || ""}
                            disabled="disabled"
                          />
                        </div>

                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="court_case_registration_certificate_name"
                            name="court_case_registration_certificate_name"
                            labelClassName={`form-label`}
                            labelText="صورة شهادة قيد الدعوى من المحكمة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="court_case_registration_certificate_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              data?.court
                                ?.court_case_registration_certificate_name
                                ? "الملف"
                                : ""
                            }
                            isIcon={
                              data?.court
                                ?.court_case_registration_certificate_img || ""
                            }
                            disabled="disabled"
                            idDownload={id}
                            filedDownload="courtCaseRegistrationCertificateFiles"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="row">
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="appeal_committee"
                            name="appeal_committee"
                            labelClassName={`form-label`}
                            labelText="لجنة الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="appeal_committee"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              data?.appeal_committee?.appeal_committee || ""
                            }
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="appeal_number"
                            name="appeal_number"
                            labelClassName={`form-label`}
                            labelText="رقم الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="appeal_number"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.appeal_committee?.appeal_number || ""}
                            disabled="disabled"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="appeal_date"
                            name="appeal_date"
                            labelClassName={`form-label`}
                            labelText="تاريخ الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="appeal_date"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={data?.appeal_committee?.appeal_date || ""}
                            disabled="disabled"
                          />
                        </div>

                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="appeal_insurance_payment_voucher_name"
                            name="appeal_insurance_payment_voucher_name"
                            labelClassName={`form-label`}
                            labelText="صورة قسيمة سداد تأمين الطعن"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="appeal_insurance_payment_voucher_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              data?.appeal_committee
                                ?.appeal_insurance_payment_voucher_name
                                ? "الملف"
                                : ""
                            }
                            isIcon={
                              data?.appeal_committee
                                ?.appeal_insurance_payment_voucher_img || ""
                            }
                            disabled="disabled"
                            idDownload={id}
                            filedDownload="appealInsurancePaymentVoucherFiles"
                          />
                        </div>
                        <div className="col-md-4">
                          <InputElement
                            mb4="mb-4"
                            labelHtmlFor="tax_notification_form"
                            name="tax_notification_form"
                            labelClassName={`form-label`}
                            labelText="صورة الإخطار بالضريبة نموذج رقم 3 أو المطالبة"
                            inputType="text"
                            inputClassName={`form-control font-grey`}
                            inputID="tax_notification_form"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            value={
                              data?.appeal_committee?.form_3_claim_name
                                ? "الملف"
                                : ""
                            }
                            isIcon={
                              data?.appeal_committee?.form_3_claim_img || ""
                            }
                            disabled="disabled"
                            idDownload={id}
                            filedDownload="taxNotificationFormFiles"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </MainContent>
      )}
    </>
  );
};
export default RequestDetails;
